import {useQuery} from "@tanstack/react-query";
import {firsGet} from "../api/firs/firsGet.ts";

export const useFirs = () => useQuery({
    queryKey: ['firs'],
    queryFn: () => firsGet().then(r => r.payload)
})